import { render, staticRenderFns } from "./itemsValoracion.vue?vue&type=template&id=4abc8e3c&scoped=true&"
import script from "./itemsValoracion.vue?vue&type=script&lang=js&"
export * from "./itemsValoracion.vue?vue&type=script&lang=js&"
import style0 from "./itemsValoracion.vue?vue&type=style&index=0&id=4abc8e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abc8e3c",
  null
  
)

export default component.exports